export const GET_ALL_JOBS_Request ="GET_ALL_JOBS_Request";
export const GET_ALL_JOBS_Success ="GET_ALL_JOBS_Success";
export const GET_ALL_JOBS_Error ="GET_ALL_JOBS_Error";


///////////////view application/////////////////

export const VIEW_APPLICATION_SUCCESS = "VIEW_APPLICATION_SUCCESS";


///////////////post new job application/////////////////
export const POST_NEW_JOB_REQUEST = "POST_NEW_JOB_REQUEST";
export const POST_NEW_JOB_SUCCESS = "POST_NEW_JOB_SUCCESS";
export const POST_NEW_JOB_ERROR = "POST_NEW_JOB_ERROR";
    

///////////////////////Delete Job/////////////////////////////////////////

export const DELETE_JOB_REQUEST = "DELETE_JOB_REQUEST";
export const DELETE_JOB_SUCCESS = "DELETE_JOB_SUCCESS";
export const DELETE_JOB_ERROR = "DELETE_JOB_ERROR";    


///////////////////////UPDATE Job/////////////////////////////////////////

export const UPDATE_JOB_REQUEST = "UPDATE_JOB_REQUEST";
export const UPDATE_JOB_SUCCESS = "UPDATE_JOB_SUCCESS";
export const UPDATE_JOB_ERROR = "UPDATE_JOB_ERROR";    